import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../stylesheet/_grid.scss";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";

const NavLinks = [
  [
    {
      linkTitle: "ZeHub",
      link: "/",
    },
    {
      linkTitle: "ZeCafe",
      link: "/cafe",
    },
    {
      linkTitle: "ZeAcademy",
      link: "/academy",
    },
  ],
  // {
  //   linkTitle: "Ze.Talent",
  //   link: "/",
  // },
  // {
  //   linkTitle: "Ze.Market",
  //   link: "/",
  // },
  // {
  //   linkTitle: "Ze.Forum",
  //   link: "/",
  // },
  // {
  //   linkTitle: "Ze.Dictonary",
  //   link: "/",
  // }],
  [
    {
      linkTitle: "الرئيسية",
      link: "/",
    },
    {
      linkTitle: "كافيه زي",
      link: "/cafe",
    },
    {
      linkTitle: "أكاديمية زي",
      link: "/academy",
    },
  ],
  // {
  //   linkTitle: "ياف.يز",
  //   link: "/",
  // },
  // {
  //   linkTitle: "هيفاك.يز",
  //   link: "/",
  // },
  // {
  //   linkTitle: "يز.ةيميداكأ",
  //   link: "/",
  // },
  // {
  //   linkTitle: "بهاوم.يز",
  //   link: "/",
  // }],
];

const FooterNavigation: React.FC = () => {
  const [click, setClick] = useState(false);
  const handleClick = () => setClick(!click);
  const { t, i18n, ready } = useTranslation();

  let lang = 0;
  if (i18n.language === "ar") {
    lang = 1;
  }

  return (
    <div className="flex">
      <div className="flex-r flex-s-between" onClick={handleClick}>
        {ready ? <h5>{t("footer.zenavigation")} </h5> : <Skeleton />}
        <span className="footer-expand-menu-btn">{click ? "-" : "+"}</span>
      </div>
      <div
        className={`ze-navigation flex-s-between ${
          click ? "" : "footer-expand-menu"
        }`}
      >
        <div className="flex">
          {NavLinks[lang].map((item) => (
            <Link
              className="p2 hover-to-change-color"
              style={{ textDecoration: "inherit" }}
              to={`/${i18n.language}${item.link}`}
              key={item.linkTitle.toString()}
            >
              {item.linkTitle}
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FooterNavigation;
